var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useState } from 'react';
import { CognitoUserPool, CognitoUserAttribute, CognitoUser, } from 'amazon-cognito-identity-js';
import { PoolData } from '../../config';
export const useCognitoRegistration = (cognitoUserPoolConfig = PoolData) => {
    const [isFetching, setFetching] = useState(false);
    const [userRegDetails, setUserDetails] = useState({
        email: '',
        userConfirmed: false,
        regCompleted: false,
        registrationErrorMsg: '',
    });
    const userPool = new CognitoUserPool(cognitoUserPoolConfig);
    const signupUser = (password, fullName, userEmail, phone) => __awaiter(void 0, void 0, void 0, function* () {
        setFetching(true);
        const attributeList = [
            new CognitoUserAttribute({ Name: 'email', Value: userEmail }),
            new CognitoUserAttribute({ Name: 'name', Value: fullName }),
            new CognitoUserAttribute({ Name: 'phone_number', Value: `+${phone}` }),
        ];
        setUserDetails(Object.assign(Object.assign({}, userRegDetails), { regCompleted: false }));
        if (userEmail && password && fullName && phone) {
            userPool.signUp(userEmail, password, attributeList, [], (err, result) => {
                if (err) {
                    setUserDetails(Object.assign(Object.assign({}, userRegDetails), { registrationErrorMsg: err.message }));
                    setFetching(false);
                    return;
                }
                const cognitoUser = result === null || result === void 0 ? void 0 : result.user;
                setUserDetails({
                    registrationErrorMsg: '',
                    email: (cognitoUser === null || cognitoUser === void 0 ? void 0 : cognitoUser.getUsername()) || '',
                    userConfirmed: (result === null || result === void 0 ? void 0 : result.userConfirmed) || false,
                    regCompleted: true,
                });
                setFetching(false);
            });
        }
    });
    const confirmRegistration = (code) => __awaiter(void 0, void 0, void 0, function* () {
        const userData = { Username: userRegDetails.email, Pool: userPool };
        const cognitoUser = new CognitoUser(userData);
        cognitoUser.confirmRegistration(code, true, (err) => {
            setFetching(true);
            if (err) {
                setUserDetails(Object.assign(Object.assign({}, userRegDetails), { registrationErrorMsg: err.message }));
                setFetching(false);
                return;
            }
            setUserDetails(Object.assign(Object.assign({}, userRegDetails), { registrationErrorMsg: '', userConfirmed: true }));
            setFetching(false);
        });
    });
    return {
        userRegDetails,
        signupUser,
        confirmRegistration,
        isFetching,
    };
};
//# sourceMappingURL=useCognitoRegistration.js.map